module.exports = __webpack_public_path__ + "img/new-to-cryptocurrency.544f337c.png";